module.exports = __webpack_public_path__ + "img/check.3c4a5982.svg";